import { Link } from "react-router-dom";
import { AlertOctagon } from "lucide-react";

export const DataHealthBanner = ({ health }) => (health && !health.ok ? (
  <div className="mb-5 flex flex-wrap items-start gap-3 rounded-xl border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-900" data-testid="data-health-banner">
    <AlertOctagon className="mt-0.5 h-5 w-5 shrink-0 text-red-600" />
    <div className="min-w-0 flex-1">
      <p className="font-semibold">No stock data found — counts can&apos;t be trusted. Upload stocks / run Repair stock flags</p>
      <ul className="mt-1 list-disc pl-5 text-xs" data-testid="data-health-problems">{health.problems.map((p) => <li key={p}>{p}</li>)}</ul>
    </div>
    <Link to="/settings/housekeeping" className="rounded-md bg-red-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-red-700" data-testid="data-health-repair-link">Repair stock flags</Link>
  </div>
) : null);
